export enum RefundStatusEnum {
	REGISTERED_1 = 1,
	REGISTERED_3 = 3,
	CANCELED_4 = 4,
	DENIED_5 = 5,
	IN_ANALYSIS_6 = 6,
	APPROVED_7 = 7,
	CONCLUDED_8 = 8,
}

export type ConsultRefundParams = {
	userCode?: string;
	protocol?: string;
	patientCode?: string;
	startDate?: string;
	endDate?: string;
	page?: number;
	limit?: number;
	protocolSituation?: number;
	modalityCode?: number;
};

export type Refund = {
	protocolCode: number;
	protocol: string;
	startDate: string;
	situationCode: RefundStatusEnum;
	registrationNumber: number;
	registration: string;
	userCode: string;
	inclusionOperator: string;
	processDate: string;
	estimatedPaymentDate: string;
	totalReimbursementAmount: number;
	totalReimbursementProtocolAmount: number;
	paymentDate: string;
	requestSource?: string;
	documentAmount: number;
	fiscalNumber: string;
	modalityCode: number;
	modalityDescription: string;
	protocolSituation: string;
	provider: string;
	request: string;
	requestCode: number;
	requestDate: string;
	requestSituation: string;
	requestSituationCode: number;
};

export type GetConsultRefundsResponse = {
	content: {
		consults: Refund[];
		total: number;
		totalPerPage: number;
	};
};

export interface GetConsultRefunds {
	get: (params?: ConsultRefundParams) => Promise<GetConsultRefundsResponse>;
}
